import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import ModalPopup from '../../../../common/components/ui/ModalPopup';
import InvoicesList from '../InvoicesList';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useOrderInvoiceFormContext} from '../../contexts/OrderInvoiceFormContext';
import {usePopupReplaceInvoiceContext} from '../../contexts/PopupReplaceInvoiceContext';
import styles from './PopupReplaceInvoice.module.scss';

const PopupReplaceInvoice = () => {
  const context = useGlobalContext();
  const {
    show,
    handleShow,
    handleClose
  } = usePopupReplaceInvoiceContext();
  const {invoices} = useOrderInvoiceFormContext();

  return (
    <>
      <ButtonAction
        variant={'button'}
        label={<FormattedMessage id={'orderInvoice-form-submit-replace'} defaultMessage={'Replace'}/>}
        onClick={handleShow}
        customClassnames={{container: styles.actionButton}}
      />
      <ModalPopup
        isOpen={show}
        onRequestClose={handleClose}
        customModalStyles={styles.modal}
      >
        <div dir={context.layoutDirection} className={styles.popupReplaceInvoiceContainer}>
          <div className={styles.title}>
            <FormattedMessage
              id={'orderInvoice-modal-invoices-title-same-month'}
              defaultMessage={'Invoices for the same month'}
            />
          </div>
          <div className={styles.content}>
            <InvoicesList data={invoices}/>
          </div>
          <div className={styles.closeButton}>
            <ButtonAction
              variant={'reject'}
              label={<FormattedMessage id={'button-label-close'} defaultMessage={'Close'}/>}
              onClick={handleClose}
            />
          </div>
        </div>
      </ModalPopup>
    </>
  );
};

export default PopupReplaceInvoice;
